import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line
    syncDoubleMiningConfig(context) {
      return api.syncDoubleMiningConfig();
    }
  }
};

appStore.registerModule('miningDouble', store);
